import moment from 'moment';

const FORMAT = 'YYYY-MM-DD';
const MAX_RANGE_DAYS = 92;

export default {
  data() {
    return {
      from: null,
      to: null,
      activePreset: 'previousMonth',
      isExporting: false,
      reportRangeAllowsToday: false,
      reportMaxRangeDays: MAX_RANGE_DAYS,
    };
  },

  computed: {
    rangeInDays() {
      if (!this.from || !this.to) return 0;
      const a = moment(this.from, FORMAT);
      const b = moment(this.to, FORMAT);
      if (!a.isValid() || !b.isValid()) return 0;
      return b.diff(a, 'days') + 1;
    },

    rangeInDaysLabel() {
      const n = this.rangeInDays;
      if (!n) return '';
      return n === 1 ? '1 ημέρα' : `${n} ημέρες`;
    },

    validationError() {
      if (!this.from || !this.to) return null;
      const a = moment(this.from, FORMAT);
      const b = moment(this.to, FORMAT);
      const today = moment().startOf('day');

      if (!a.isValid() || !b.isValid()) {
        return 'Μη έγκυρες ημερομηνίες.';
      }
      if (a.isAfter(b)) {
        return 'Η ημερομηνία «Από» πρέπει να είναι πριν ή ίδια με την «Έως».';
      }
      if (this.reportRangeAllowsToday ? b.isAfter(today) : !b.isBefore(today)) {
        return this.reportRangeAllowsToday
          ? 'Η ημερομηνία «Έως» δεν μπορεί να είναι στο μέλλον.'
          : 'Η ημερομηνία «Έως» πρέπει να είναι στο παρελθόν.';
      }
      if (
        this.reportMaxRangeDays &&
        this.rangeInDays > this.reportMaxRangeDays
      ) {
        return `Το διάστημα είναι μεγάλο (${this.rangeInDays} ημέρες). Επιτρέπεται έως ${this.reportMaxRangeDays} ημέρες.`;
      }
      return null;
    },

    canExport() {
      return Boolean(
        this.from && this.to && !this.validationError && !this.isExporting,
      );
    },
  },

  mounted() {
    this.applyPreset('previousMonth');
  },

  methods: {
    isAfterToday(date) {
      return moment(date)
        .startOf('day')
        .isAfter(moment().startOf('day'));
    },

    onCustomDateChange() {
      this.activePreset = 'custom';
    },

    computeRange(preset) {
      const today = moment().startOf('day');
      const yesterday = today.clone().subtract(1, 'day');
      const latest = this.reportRangeAllowsToday ? today : yesterday;
      const isFirstDayOfMonth =
        !this.reportRangeAllowsToday &&
        today
          .clone()
          .startOf('month')
          .isAfter(yesterday);
      const isFirstDayOfQuarter =
        !this.reportRangeAllowsToday &&
        today
          .clone()
          .startOf('quarter')
          .isAfter(yesterday);

      let effective = preset;
      if (preset === 'currentMonth' && isFirstDayOfMonth) {
        effective = 'previousMonth';
      }
      if (preset === 'currentQuarter' && isFirstDayOfQuarter) {
        effective = 'previousQuarter';
      }

      if (effective === 'currentMonth') {
        return {
          from: today.clone().startOf('month'),
          to: latest,
          preset: effective,
        };
      }
      if (effective === 'previousMonth') {
        return {
          from: today
            .clone()
            .subtract(1, 'month')
            .startOf('month'),
          to: today
            .clone()
            .subtract(1, 'month')
            .endOf('month'),
          preset: effective,
        };
      }
      if (effective === 'last30Days') {
        return {
          from: latest.clone().subtract(29, 'days'),
          to: latest,
          preset: effective,
        };
      }
      if (effective === 'currentQuarter') {
        return {
          from: today.clone().startOf('quarter'),
          to: latest,
          preset: effective,
        };
      }
      if (effective === 'previousQuarter') {
        return {
          from: today
            .clone()
            .subtract(1, 'quarter')
            .startOf('quarter'),
          to: today
            .clone()
            .subtract(1, 'quarter')
            .endOf('quarter'),
          preset: effective,
        };
      }
      return null;
    },

    applyPreset(preset) {
      const range = this.computeRange(preset);
      if (!range) return;
      this.from = range.from.format(FORMAT);
      this.to = range.to.format(FORMAT);
      this.activePreset = range.preset;
    },
  },
};
